<template>
  <v-dialog
    :value="value"
    max-width="700"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        {{ $t('leaveWhileOrderInProgressDialog.title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('leaveWhileOrderInProgressDialog.message') }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <tc-v-btn
          id="leave-while-order-processing-confirm-btn"
          tabindex="1"
          color="error"
          @click="$emit('confirm')"
        >
          {{ $t('leaveWhileOrderInProgressDialog.confirmButton') }}
        </tc-v-btn>

        <tc-v-btn
          id="leave-while-order-processing-cancel-btn"
          tabindex="0"
          color="primary"
          @click="$emit('cancel')"
        >
          {{ $t('leaveWhileOrderInProgressDialog.cancelButton') }}
        </tc-v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LeaveWhileOrderProcessingDialog',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped></style>
